import { render } from "./GravyDropdownMenu.vue?vue&type=template&id=bbeaa8e8"
import script from "./GravyDropdownMenu.vue?vue&type=script&lang=js"
export * from "./GravyDropdownMenu.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/whisk/whisk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__